module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5ae6eb3491ba7629cf91e7905dff6171.png";